import { render, staticRenderFns } from "./openDetail.vue?vue&type=template&id=a9f64d34&scoped=true"
import script from "./openDetail.vue?vue&type=script&lang=js"
export * from "./openDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f64d34",
  null
  
)

export default component.exports